import { getShiftAttendanceAnalyticsFunctionDef } from '../../../../backend/features/shift/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import useSWR from 'swr';
export const shiftAttendanceFetchKey = 'shiftAttendanceAnalytics';
export const useShiftAttendanceAnalytics = ({ shiftId }) => {
    const getShiftAttendanceAnalyticsPlatformFn = useTypedPlatformFunction(getShiftAttendanceAnalyticsFunctionDef);
    function getShiftAttendanceAnalytics() {
        return getShiftAttendanceAnalyticsPlatformFn({ shiftId });
    }
    const { data: shiftAttendanceAnalytics, mutate } = useSWR([shiftAttendanceFetchKey, shiftId], () => getShiftAttendanceAnalytics().catch(handleErrorSnackbar), defaultFetcherOptions);
    return {
        reloadAnalytics: mutate,
        shiftAttendanceAnalytics: shiftAttendanceAnalytics !== null && shiftAttendanceAnalytics !== void 0 ? shiftAttendanceAnalytics : {
            checkedInParticipantsCount: 0,
            checkedOutParticipantsCount: 0,
            notCheckedInParticipantsCount: 0,
        },
    };
};
